module.exports = __webpack_public_path__ + "img/pen-swirl.26fc7652.svg";